export default __webpack_public_path__ + "static/media/step3.87e79c93.png";